import { Component, ComponentRef, Injector, Input, NgZone, ViewContainerRef, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { BaseComponentWithDialog } from "../../../admin-panel/base-admin-panel/base-component-with-dialog";
import { GeozoneViewModel } from "../../../admin-panel/Geozone/Model/GeozoneViewModel";
import { CreateGeozoneDialogComponent } from "../../../admin-panel/Geozone/create-geozone-dialog/create-geozone-dialog.component";
import { JSProxyService } from "../../../../services/jsproxy.service";

import { ObjectGroupViewModel } from "../../../admin-panel/ObjectGroupViewModel";
import { GroupManagementDialogComponent } from "../../../admin-panel/group-management-dialog/group-management-dialog.component";

@Component({
    selector: 'app-geozones-list',
    templateUrl: './geozones-list.component.html',
    styleUrls: ['./geozones-list.component.css'],
    standalone: false
})

export class GeozonesListComponent extends BaseComponentWithDialog implements OnInit,OnDestroy
{
  groupMgmtDialog: ComponentRef<any>;
  @ViewChild("groupMgmtDialog", { read: ViewContainerRef, static: true }) groupsContainer;

  jsProxy: JSProxyService;
  ngZone: NgZone;
  constructor(protected injector: Injector)
  {
    super(injector);
    this.jsProxy = injector.get(JSProxyService);
    this.ngZone = injector.get(NgZone);
  }
  ngOnInit()
  {
    this.jsProxy.registerComponent("GeozoneEditor", this, "");
  }
  ngOnDestroy()
  {
    this.jsProxy.unRegisterComponent("GeozoneEditor");
  }
  public show(type: string, points: string) {
    this.ngZone.run(() => {

      const model = new GeozoneViewModel();
      model.Style.type = type;
      model.Style.strokeColor = "#2233FF";
      model.Style.strokeWidth = 2;
      model.Style.strokeOpacity = (type == "polyline") ? 1 : 0.2;
      model.Style.fillColor = "#2233FF";
      model.Style.fillOpacity = 0.2;
      model.Points = points;
      this.prepareModal(CreateGeozoneDialogComponent);
      this.componentRef.instance.open(model);
    });
  }

  //public edit(driver: DriverWithGroupsViewModel) {
    //this.prepareModal(EditDriverComponent);
    //this.componentRef.instance.open(driver);
 // }

  public сreate()
  {
    //this.prepareModal(CreateDriverComponent);
    //this.componentRef.instance.open(new DriverWithGroupsViewModel());
  }
  public createGroup()
  {
    this.ngZone.run(() => {
      this.groupMgmtDialog = this.dialogService.open(this.groupsContainer, GroupManagementDialogComponent);

      this.groupMgmtDialog.instance.onSubmit.subscribe(() => {
        this.groupMgmtDialog.instance.close();
      });

      this.groupMgmtDialog.instance.open(new ObjectGroupViewModel());
    });
  }
}
